import React from 'react'
import { SiteHeader as Component } from '@swp/components'

export default function SiteHeader(props) {
return (
  <Component className="pos--fix --spacing4 --size-L" type={"SiteHeader"} item={{"color":"rgba(25,53,125,1)","colorHover":"rgba(25,53,125,0.5)","className":"fs--18"}} fixed={true} title={{"color":"rgba(25,53,125,1)","content":"Dárkové poukazy","className":"fs--26 w--700 ls--002"}} layout={"3"} social={{"twitter":"saywebpage","facebook":"saywebpage","instagram":"saywebpage"}} backgroundColor={"rgba(244,245,249,1)"} button={{"className":"btn-box"}} />
)
}